import { defineStore } from 'pinia'

export default defineStore({
  id: 'systemAlert',
  persist: true,
  state: () => {
    return {
      visible: false,
      content: '',
      route: null,
      style: {
        backgroundColor: '#FFF',
        color: '#333'
      },
      options: {
        scheduleDeadline: '',
        scheduleCompleted: false
      }
    }
  },
  actions: {
    setAlertVisible: function (payload: any, content?: string, route?: any, style?: any, options?: any) {
      this.visible = !!payload
      if (content) {
        this.content = content
      }
      if (route) {
        this.route = route
      }
      if (options !== undefined && typeof options === 'object') {
        Object.assign(this.options, options)
      }
      if (style !== undefined && typeof style === 'object') {
        Object.assign(this.style, style)
      }
    },
    setAlertContent: function (payload: any) {
      this.content = payload || ''
    },
    setAlertStyle: function (payload: any) {
      Object.assign(this.style, payload || {})
    },
    setAlertOptions: function (payload: any) {
      if (payload !== undefined && typeof payload === 'object') {
        Object.assign(this.options, payload)
      }
    },
    setAlertRoute: function (payload: any) {
      this.route = payload
    }
  },
  getters: {}
})
